
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire37b7"];
var parcelRegister = parcelRequire.register;
parcelRegister("8iEgn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60af3c968af4b9f4$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $c4OEa = parcelRequire("c4OEa");

var $9X0U9 = parcelRequire("9X0U9");
var $TJrLs = parcelRequire("TJrLs");
var $ijE2m = parcelRequire("ijE2m");
var $lBrex = parcelRequire("lBrex");

var $1fll9 = parcelRequire("1fll9");
var $60af3c968af4b9f4$var$containerStyles = (0, $lBrex.xcss)({
    wordBreak: "break-word",
    borderRadius: "border.radius"
});
var $60af3c968af4b9f4$var$bleedStyles = (0, $lBrex.xcss)({
    display: "flex",
    marginBlock: "space.negative.025"
});
var $60af3c968af4b9f4$var$contentStyles = (0, $lBrex.xcss)({
    color: "color.text",
    font: "font.body"
});
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ var $60af3c968af4b9f4$var$SectionMessage = /*#__PURE__*/ (0, $91i6m.forwardRef)(function SectionMessage(_ref, ref) {
    var children = _ref.children, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "information" : _ref$appearance, actions = _ref.actions, title = _ref.title, icon = _ref.icon, testId = _ref.testId;
    var _getAppearanceIconSty = (0, $1fll9.getAppearanceIconStyles)(appearance, icon), primaryColor = _getAppearanceIconSty.primaryIconColor, secondaryColor = _getAppearanceIconSty.backgroundColor, Icon = _getAppearanceIconSty.Icon;
    var actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment ? actions.props.children : actions;
    var actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9X0U9.default), {
        as: "section",
        backgroundColor: $60af3c968af4b9f4$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $60af3c968af4b9f4$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $TJrLs.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9X0U9.default), {
        xcss: $60af3c968af4b9f4$var$bleedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        LEGACY_size: "medium",
        color: primaryColor,
        spacing: "spacious"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $ijE2m.default), {
        space: "space.100",
        testId: testId && "".concat(testId, "--content")
    }, !!title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $c4OEa.default), {
        as: "h2",
        size: "small"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9X0U9.default), {
        xcss: $60af3c968af4b9f4$var$contentStyles
    }, children), actionsArray.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $TJrLs.default), {
        shouldWrap: true,
        testId: testId && "".concat(testId, "--actions"),
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0",
        role: "list"
    }, actionsArray.map(function(action, id) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $TJrLs.default), {
            role: "listitem",
            key: id
        }, action);
    })))));
});
var $60af3c968af4b9f4$var$appearanceMap = {
    information: "color.background.information",
    warning: "color.background.warning",
    error: "color.background.danger",
    success: "color.background.success",
    discovery: "color.background.discovery"
};
$60af3c968af4b9f4$var$SectionMessage.displayName = "SectionMessage";
var $60af3c968af4b9f4$export$2e2bcd8739ae039 = $60af3c968af4b9f4$var$SectionMessage;

});
parcelRegister("c4OEa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cad2524638faa76$export$2e2bcd8739ae039; });

var $5YM7L = parcelRequire("5YM7L");

var $lPOF7 = parcelRequire("lPOF7");

var $7re4P = parcelRequire("7re4P");
var $hZpnm = parcelRequire("hZpnm");

var $7n972 = parcelRequire("7n972");

var $e08gr = parcelRequire("e08gr");
var $8cad2524638faa76$var$sizeTagMap = {
    xxlarge: "h1",
    xlarge: "h1",
    large: "h2",
    medium: "h3",
    small: "h4",
    xsmall: "h5",
    xxsmall: "h6"
};
var $8cad2524638faa76$var$headingResetStyles = (0, $lPOF7.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    letterSpacing: "normal",
    marginBlock: 0,
    textTransform: "none"
});
var $8cad2524638faa76$var$useColor = function useColor(colorProp) {
    var surface = (0, $hZpnm.useSurface)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $7re4P.inverseColorMap).hasOwnProperty(surface)) return (0, $7re4P.inverseColorMap)[surface];
    return colorProp || "color.text";
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $8cad2524638faa76$var$Heading = function Heading(_ref) {
    var children = _ref.children, size = _ref.size, id = _ref.id, testId = _ref.testId, as = _ref.as, colorProp = _ref.color;
    typeof $e08gr;
    // Technically size can be undefined here due to how the types work.
    // Once removing the level prop this assertion can be removed since size will be a required prop.
    var _useHeading = (0, $7n972.useHeading)($8cad2524638faa76$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === "div" && hLevel;
    var color = $8cad2524638faa76$var$useColor(colorProp);
    return (0, $lPOF7.jsx)(Component, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $8cad2524638faa76$var$headingResetStyles,
            size && $8cad2524638faa76$var$headingSizeStylesMap[size],
            $8cad2524638faa76$var$headingColorStylesMap[color]
        ]
    }, children);
};
var $8cad2524638faa76$var$headingColorStylesMap = {
    "color.text": (0, $lPOF7.css)({
        color: "var(--ds-text, #172B4D)"
    }),
    "color.text.inverse": (0, $lPOF7.css)({
        color: "var(--ds-text-inverse, #FFFFFF)"
    }),
    "color.text.warning.inverse": (0, $lPOF7.css)({
        color: "var(--ds-text-warning-inverse, #172B4D)"
    })
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df829c6c0aa19bb57c0c77dc08d12d60>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $8cad2524638faa76$var$headingSizeStylesMap = {
    xxlarge: (0, $lPOF7.css)({
        font: 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xlarge: (0, $lPOF7.css)({
        font: 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    large: (0, $lPOF7.css)({
        font: 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    medium: (0, $lPOF7.css)({
        font: 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    small: (0, $lPOF7.css)({
        font: 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xsmall: (0, $lPOF7.css)({
        font: 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xxsmall: (0, $lPOF7.css)({
        font: 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    })
};
var /**
 * @codegenEnd
 */ $8cad2524638faa76$export$2e2bcd8739ae039 = $8cad2524638faa76$var$Heading;

});
parcelRegister("7n972", function(module, exports) {

$parcel$export(module.exports, "useHeading", function () { return $55e1bff6ee8a733c$export$97a37b1befbbf9b1; });

var $91i6m = parcelRequire("91i6m");
// Allows support for heading levels 1-9 via aria-level
var $55e1bff6ee8a733c$var$HeadingLevelContext = /*#__PURE__*/ (0, $91i6m.createContext)(0);
var $55e1bff6ee8a733c$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $91i6m.useContext)($55e1bff6ee8a733c$var$HeadingLevelContext);
};
var $55e1bff6ee8a733c$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $55e1bff6ee8a733c$export$6a64a1e2d0bbbf75();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? "div" : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $55e1bff6ee8a733c$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $55e1bff6ee8a733c$export$6a64a1e2d0bbbf75();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($55e1bff6ee8a733c$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $55e1bff6ee8a733c$export$2e2bcd8739ae039 = $55e1bff6ee8a733c$var$HeadingLevelContextProvider;

});


parcelRegister("1fll9", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", function () { return $0e87bee448892c08$export$e9b82d2e21ac0c1f; });

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $9peCk = parcelRequire("9peCk");

var $5RRXr = parcelRequire("5RRXr");

var $3ok70 = parcelRequire("3ok70");

var $gvwoZ = parcelRequire("gvwoZ");

var $iOmjJ = parcelRequire("iOmjJ");

var $gE12B = parcelRequire("gE12B");
function $0e87bee448892c08$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0e87bee448892c08$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0e87bee448892c08$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0e87bee448892c08$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0e87bee448892c08$export$faa35441caff5bb6 = {
    information: {
        backgroundColor: "var(--ds-background-information, ".concat((0, $gE12B.B50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3ok70))),
        primaryIconColor: "var(--ds-icon-information, ".concat((0, $gE12B.B500), ")")
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, ".concat((0, $gE12B.Y50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($iOmjJ))),
        primaryIconColor: "var(--ds-icon-warning, ".concat((0, $gE12B.Y500), ")")
    },
    error: {
        backgroundColor: "var(--ds-background-danger, ".concat((0, $gE12B.R50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5RRXr))),
        primaryIconColor: "var(--ds-icon-danger, ".concat((0, $gE12B.R500), ")")
    },
    success: {
        backgroundColor: "var(--ds-background-success, ".concat((0, $gE12B.G50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9peCk))),
        primaryIconColor: "var(--ds-icon-success, ".concat((0, $gE12B.G500), ")")
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, ".concat((0, $gE12B.P50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gvwoZ))),
        primaryIconColor: "var(--ds-icon-discovery, ".concat((0, $gE12B.P500), ")")
    }
};
function $0e87bee448892c08$export$e9b82d2e21ac0c1f(appearance, icon) {
    var appearanceIconStyles = $0e87bee448892c08$export$faa35441caff5bb6[appearance] || $0e87bee448892c08$export$faa35441caff5bb6.information;
    var AppearanceIcon = function AppearanceIcon(_ref) {
        var size = _ref.size, primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(appearanceIconStyles.Icon, {
            size: size,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            label: appearance
        });
    };
    var Icon = icon || AppearanceIcon;
    return $0e87bee448892c08$var$_objectSpread($0e87bee448892c08$var$_objectSpread({}, appearanceIconStyles), {}, {
        Icon: Icon
    });
}

});
parcelRegister("9peCk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d91c98d8e9a7833$var$_react = $6d91c98d8e9a7833$var$_interopRequireDefault((parcelRequire("91i6m")));

var $3CjS9 = parcelRequire("3CjS9");

var $6d91c98d8e9a7833$var$_success = $6d91c98d8e9a7833$var$_interopRequireDefault((parcelRequire("jrK23")));
function $6d91c98d8e9a7833$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6d91c98d8e9a7833$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $6d91c98d8e9a7833$var$_react.default.createElement($3CjS9.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $6d91c98d8e9a7833$var$_success.default
    }));
$6d91c98d8e9a7833$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $6d91c98d8e9a7833$var$_default = module.exports.default = $6d91c98d8e9a7833$var$CheckCircleIcon;

});
parcelRegister("3CjS9", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $2a2455f1818e2f67$export$3cfb73f70dfca966; });

var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $f1k1y = parcelRequire("f1k1y");

var $7NPFp = parcelRequire("7NPFp");
var $2a2455f1818e2f67$var$_excluded = [
    "dangerouslySetGlyph"
];
var $2a2455f1818e2f67$var$sizeSpacingMap = {
    utility: {
        small: "compact",
        medium: "spacious"
    },
    core: {
        small: "none",
        medium: "spacious"
    }
};
var $2a2455f1818e2f67$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $91i6m.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $2a2455f1818e2f67$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $f1k1y.fg)("platform-visual-refresh-icons-legacy-facade");
    if (useNewIcon && NewIcon && (size === "small" || size === "medium")) {
        if (props.iconType === "utility") {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, props, {
                spacing: (0, $f1k1y.fg)("platform-visual-refresh-icons-facade-button-fix") ? $2a2455f1818e2f67$var$sizeSpacingMap["utility"][size] : "none",
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, props, {
                spacing: $2a2455f1818e2f67$var$sizeSpacingMap["core"][size],
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $7NPFp.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});
var $2a2455f1818e2f67$export$2e2bcd8739ae039 = $2a2455f1818e2f67$export$3cfb73f70dfca966;

});
parcelRegister("7NPFp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ae52ffe880a1805$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $lPOF7 = parcelRequire("lPOF7");

var $cuo1N = parcelRequire("cuo1N");

var $9u3Vx = parcelRequire("9u3Vx");
function $5ae52ffe880a1805$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5ae52ffe880a1805$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5ae52ffe880a1805$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5ae52ffe880a1805$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $5ae52ffe880a1805$var$iconStyles = (0, $lPOF7.css)({
    display: "inline-block",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $5ae52ffe880a1805$var$_objectSpread($5ae52ffe880a1805$var$_objectSpread({}, (0, $cuo1N.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $5ae52ffe880a1805$var$baseHcmStyles = (0, $lPOF7.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $5ae52ffe880a1805$var$primaryEqualsSecondaryHcmStyles = (0, $lPOF7.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $5ae52ffe880a1805$var$secondaryTransparentHcmStyles = (0, $lPOF7.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $5ae52ffe880a1805$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $lPOF7.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $cuo1N.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $lPOF7.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $9u3Vx.getBackground)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $5ae52ffe880a1805$var$iconStyles,
            $5ae52ffe880a1805$var$baseHcmStyles,
            primaryColor === secondaryColor && $5ae52ffe880a1805$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $5ae52ffe880a1805$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $lPOF7.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $5ae52ffe880a1805$export$2e2bcd8739ae039 = $5ae52ffe880a1805$export$f04a61298a47a40f;

});
parcelRegister("cuo1N", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $917aecda6cf98f5c$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $917aecda6cf98f5c$export$3eb7d6130acfda37; });

var $YXmcy = parcelRequire("YXmcy");

var $lPOF7 = parcelRequire("lPOF7");
var $917aecda6cf98f5c$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $917aecda6cf98f5c$var$smallStyles = (0, $lPOF7.css)((0, $YXmcy.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $917aecda6cf98f5c$var$mediumStyles = (0, $lPOF7.css)((0, $YXmcy.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $917aecda6cf98f5c$var$largeStyles = (0, $lPOF7.css)((0, $YXmcy.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $917aecda6cf98f5c$var$xlargeStyles = (0, $lPOF7.css)((0, $YXmcy.dimensions).xlarge);
var $917aecda6cf98f5c$export$ef0ad74202575b64 = {
    small: $917aecda6cf98f5c$var$smallStyles,
    medium: $917aecda6cf98f5c$var$mediumStyles,
    large: $917aecda6cf98f5c$var$largeStyles,
    xlarge: $917aecda6cf98f5c$var$xlargeStyles
};
var $917aecda6cf98f5c$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $YXmcy.dimensions)[size];
    return undefined;
};

});
parcelRegister("YXmcy", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $0b73a5caefcd0566$export$62ad7b0c781000e9; });
var $0b73a5caefcd0566$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $0b73a5caefcd0566$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $0b73a5caefcd0566$export$62ad7b0c781000e9 = {
    small: {
        width: $0b73a5caefcd0566$export$c647cb0ee6e282fe.small,
        height: $0b73a5caefcd0566$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $0b73a5caefcd0566$export$c647cb0ee6e282fe.medium,
        height: $0b73a5caefcd0566$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $0b73a5caefcd0566$export$c647cb0ee6e282fe.large,
        height: $0b73a5caefcd0566$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $0b73a5caefcd0566$export$c647cb0ee6e282fe.xlarge,
        height: $0b73a5caefcd0566$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("9u3Vx", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $6e79f635bb7a8ac0$export$18cb9425622d4e06; });
var $6e79f635bb7a8ac0$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});



parcelRegister("jrK23", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7ae37a1f14d19f2b0729f698ebae69c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2843efb2123554f$var$_react = $e2843efb2123554f$var$_interopRequireDefault((parcelRequire("91i6m")));

var $e2843efb2123554f$var$_baseNew = $e2843efb2123554f$var$_interopRequireDefault((parcelRequire("l88m1")));
function $e2843efb2123554f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e2843efb2123554f$var$SuccessIcon = (props)=>/*#__PURE__*/ $e2843efb2123554f$var$_react.default.createElement($e2843efb2123554f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$e2843efb2123554f$var$SuccessIcon.displayName = "SuccessIcon";
var $e2843efb2123554f$var$_default = module.exports.default = $e2843efb2123554f$var$SuccessIcon;

});
parcelRegister("l88m1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("lCUju")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("lCUju")).Icon; });

var $lCUju = parcelRequire("lCUju");

});
parcelRegister("lCUju", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $fbe8d43e2d8c261a$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $fbe8d43e2d8c261a$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $91i6m = parcelRequire("91i6m");

var $lPOF7 = parcelRequire("lPOF7");

var $f1k1y = parcelRequire("f1k1y");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $fbe8d43e2d8c261a$var$commonSVGStyles = (0, $lPOF7.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $fbe8d43e2d8c261a$var$svgStyles = (0, $lPOF7.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $fbe8d43e2d8c261a$var$iconStyles = (0, $lPOF7.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $fbe8d43e2d8c261a$var$utilityIconStyles = (0, $lPOF7.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-150, 12px)"
});
var $fbe8d43e2d8c261a$var$scaleStyles = (0, $lPOF7.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $fbe8d43e2d8c261a$var$baseHcmStyles = (0, $lPOF7.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $fbe8d43e2d8c261a$var$scaleSize = (0, $lPOF7.css)({
    width: "inherit",
    height: "inherit"
});
var $fbe8d43e2d8c261a$var$sizeMap = {
    core: {
        none: (0, $lPOF7.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $lPOF7.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $lPOF7.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $lPOF7.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $lPOF7.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $fbe8d43e2d8c261a$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $fbe8d43e2d8c261a$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $fbe8d43e2d8c261a$export$f04a61298a47a40f = /*#__PURE__*/ (0, $91i6m.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $f1k1y.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return (0, $lPOF7.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $fbe8d43e2d8c261a$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core"];
    var viewBoxPadding;
    if (props.type === "utility") {
        var _props$spacing;
        viewBoxPadding = $fbe8d43e2d8c261a$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : "none"];
    } else {
        var _props$spacing2;
        viewBoxPadding = $fbe8d43e2d8c261a$var$paddingMap["core"][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : "none"];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = '\n<filter id="ds-newIconOpacityFilter">\n  <feFlood flood-color="var(--ds-icon-disabled)" />\n  <feComposite in2="SourceGraphic" operator="in" />\n</filter>\n<g filter="url(#ds-newIconOpacityFilter)">\n  '.concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $lPOF7.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $fbe8d43e2d8c261a$var$iconStyles,
            $fbe8d43e2d8c261a$var$baseHcmStyles,
            shouldScale && $fbe8d43e2d8c261a$var$scaleStyles,
            props.type === "utility" && $fbe8d43e2d8c261a$var$utilityIconStyles
        ]
    }, (0, $lPOF7.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $fbe8d43e2d8c261a$var$commonSVGStyles,
            $fbe8d43e2d8c261a$var$svgStyles,
            shouldScale ? $fbe8d43e2d8c261a$var$scaleSize : props.type === "utility" ? $fbe8d43e2d8c261a$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : "none"] : $fbe8d43e2d8c261a$var$sizeMap["core"][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : "none"]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $fbe8d43e2d8c261a$export$2e2bcd8739ae039 = $fbe8d43e2d8c261a$export$f04a61298a47a40f;

});




parcelRegister("5RRXr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $445bc1e03bd60ed9$var$_react = $445bc1e03bd60ed9$var$_interopRequireDefault((parcelRequire("91i6m")));

var $3CjS9 = parcelRequire("3CjS9");

var $445bc1e03bd60ed9$var$_error = $445bc1e03bd60ed9$var$_interopRequireDefault((parcelRequire("ej6b3")));
function $445bc1e03bd60ed9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $445bc1e03bd60ed9$var$ErrorIcon = (props)=>/*#__PURE__*/ $445bc1e03bd60ed9$var$_react.default.createElement($3CjS9.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $445bc1e03bd60ed9$var$_error.default
    }));
$445bc1e03bd60ed9$var$ErrorIcon.displayName = "ErrorIcon";
var $445bc1e03bd60ed9$var$_default = module.exports.default = $445bc1e03bd60ed9$var$ErrorIcon;

});
parcelRegister("ej6b3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::26a7f8ba76b6fb196d278ccd806e7665>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6a7a1bc6eb8fc5a$var$_react = $a6a7a1bc6eb8fc5a$var$_interopRequireDefault((parcelRequire("91i6m")));

var $a6a7a1bc6eb8fc5a$var$_baseNew = $a6a7a1bc6eb8fc5a$var$_interopRequireDefault((parcelRequire("l88m1")));
function $a6a7a1bc6eb8fc5a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6a7a1bc6eb8fc5a$var$ErrorIcon = (props)=>/*#__PURE__*/ $a6a7a1bc6eb8fc5a$var$_react.default.createElement($a6a7a1bc6eb8fc5a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$a6a7a1bc6eb8fc5a$var$ErrorIcon.displayName = "ErrorIcon";
var $a6a7a1bc6eb8fc5a$var$_default = module.exports.default = $a6a7a1bc6eb8fc5a$var$ErrorIcon;

});


parcelRegister("3ok70", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $278336d4ca5b2fe1$var$_react = $278336d4ca5b2fe1$var$_interopRequireDefault((parcelRequire("91i6m")));

var $3CjS9 = parcelRequire("3CjS9");

var $278336d4ca5b2fe1$var$_information = $278336d4ca5b2fe1$var$_interopRequireDefault((parcelRequire("iKS5G")));
function $278336d4ca5b2fe1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $278336d4ca5b2fe1$var$InfoIcon = (props)=>/*#__PURE__*/ $278336d4ca5b2fe1$var$_react.default.createElement($3CjS9.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $278336d4ca5b2fe1$var$_information.default
    }));
$278336d4ca5b2fe1$var$InfoIcon.displayName = "InfoIcon";
var $278336d4ca5b2fe1$var$_default = module.exports.default = $278336d4ca5b2fe1$var$InfoIcon;

});
parcelRegister("iKS5G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::802e7180e4bad8535c3897c96ba9ef98>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $da767b223a845d9c$var$_react = $da767b223a845d9c$var$_interopRequireDefault((parcelRequire("91i6m")));

var $da767b223a845d9c$var$_baseNew = $da767b223a845d9c$var$_interopRequireDefault((parcelRequire("l88m1")));
function $da767b223a845d9c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $da767b223a845d9c$var$InformationIcon = (props)=>/*#__PURE__*/ $da767b223a845d9c$var$_react.default.createElement($da767b223a845d9c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$da767b223a845d9c$var$InformationIcon.displayName = "InformationIcon";
var $da767b223a845d9c$var$_default = module.exports.default = $da767b223a845d9c$var$InformationIcon;

});


parcelRegister("gvwoZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c048acfd9a225c06$var$_react = $c048acfd9a225c06$var$_interopRequireDefault((parcelRequire("91i6m")));

var $3CjS9 = parcelRequire("3CjS9");

var $c048acfd9a225c06$var$_questionCircle = $c048acfd9a225c06$var$_interopRequireDefault((parcelRequire("45Z1R")));
function $c048acfd9a225c06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c048acfd9a225c06$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $c048acfd9a225c06$var$_react.default.createElement($3CjS9.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props, {
        newIcon: $c048acfd9a225c06$var$_questionCircle.default
    }));
$c048acfd9a225c06$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $c048acfd9a225c06$var$_default = module.exports.default = $c048acfd9a225c06$var$QuestionCircleIcon;

});
parcelRegister("45Z1R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df4bbc99bdb01b5c5a1f64da51109c90>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2fb6f81fbfb51192$var$_react = $2fb6f81fbfb51192$var$_interopRequireDefault((parcelRequire("91i6m")));

var $2fb6f81fbfb51192$var$_baseNew = $2fb6f81fbfb51192$var$_interopRequireDefault((parcelRequire("l88m1")));
function $2fb6f81fbfb51192$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2fb6f81fbfb51192$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $2fb6f81fbfb51192$var$_react.default.createElement($2fb6f81fbfb51192$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6C6.25 5 7 4.25 8 4.25S9.75 5 9.75 6C9.75 7.5 8 7.5 8 8.75v.75M15.25 8A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$2fb6f81fbfb51192$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $2fb6f81fbfb51192$var$_default = module.exports.default = $2fb6f81fbfb51192$var$QuestionCircleIcon;

});


parcelRegister("iOmjJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db1e353cadfdd395$var$_react = $db1e353cadfdd395$var$_interopRequireDefault((parcelRequire("91i6m")));

var $3CjS9 = parcelRequire("3CjS9");

var $db1e353cadfdd395$var$_warning = $db1e353cadfdd395$var$_interopRequireDefault((parcelRequire("9BeNH")));
function $db1e353cadfdd395$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $db1e353cadfdd395$var$WarningIcon = (props)=>/*#__PURE__*/ $db1e353cadfdd395$var$_react.default.createElement($3CjS9.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $db1e353cadfdd395$var$_warning.default
    }));
$db1e353cadfdd395$var$WarningIcon.displayName = "WarningIcon";
var $db1e353cadfdd395$var$_default = module.exports.default = $db1e353cadfdd395$var$WarningIcon;

});
parcelRegister("9BeNH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::175f2e1fa7434f09e7170a431a1877f0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6fd30cd69b83ce25$var$_react = $6fd30cd69b83ce25$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6fd30cd69b83ce25$var$_baseNew = $6fd30cd69b83ce25$var$_interopRequireDefault((parcelRequire("l88m1")));
function $6fd30cd69b83ce25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6fd30cd69b83ce25$var$WarningIcon = (props)=>/*#__PURE__*/ $6fd30cd69b83ce25$var$_react.default.createElement($6fd30cd69b83ce25$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.757-1.395 2.76-1.395 3.516 0l5.9 10.878C16.381 13.38 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$6fd30cd69b83ce25$var$WarningIcon.displayName = "WarningIcon";
var $6fd30cd69b83ce25$var$_default = module.exports.default = $6fd30cd69b83ce25$var$WarningIcon;

});


parcelRegister("gE12B", function(module, exports) {

$parcel$export(module.exports, "R50", function () { return $0320890a3ceca095$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R500", function () { return $0320890a3ceca095$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $0320890a3ceca095$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y500", function () { return $0320890a3ceca095$export$874739ea9e379ab6; });
$parcel$export(module.exports, "G50", function () { return $0320890a3ceca095$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G500", function () { return $0320890a3ceca095$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $0320890a3ceca095$export$226de0355ed012f8; });
$parcel$export(module.exports, "B500", function () { return $0320890a3ceca095$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "P50", function () { return $0320890a3ceca095$export$363e4475840015bb; });
$parcel$export(module.exports, "P500", function () { return $0320890a3ceca095$export$147899de772240ec; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $0320890a3ceca095$export$4b84fd0e2c617bd = "#FFEBE6";
var $0320890a3ceca095$export$b34b069eff244586 = "#FFBDAD";
var $0320890a3ceca095$export$be802dd0d8b57f35 = "#FF8F73";
var $0320890a3ceca095$export$60847d42f9da92a6 = "#FF7452";
var $0320890a3ceca095$export$4a7404f376229999 = "#FF5630";
var $0320890a3ceca095$export$2010d0fb4295b346 = "#DE350B";
var $0320890a3ceca095$export$2837b5a1a71d5c02 = "#BF2600";
var $0320890a3ceca095$export$8d9596b529bbb9cf = "#FFFAE6";
var $0320890a3ceca095$export$41060a744ab0b7ae = "#FFF0B3";
var $0320890a3ceca095$export$1cc05bbbf340e559 = "#FFE380";
var $0320890a3ceca095$export$5aae31392d72caaa = "#FFC400";
var $0320890a3ceca095$export$c6930421db9fa514 = "#FFAB00";
var $0320890a3ceca095$export$59619663aa6500fb = "#FF991F";
var $0320890a3ceca095$export$874739ea9e379ab6 = "#FF8B00";
var $0320890a3ceca095$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $0320890a3ceca095$export$69a3bf21b9686c2b = "#ABF5D1";
var $0320890a3ceca095$export$afbce1382ec95f73 = "#79F2C0";
var $0320890a3ceca095$export$747d86715d4175de = "#57D9A3";
var $0320890a3ceca095$export$940e1f69e873f202 = "#36B37E";
var $0320890a3ceca095$export$a49394138f7b8e85 = "#00875A";
var $0320890a3ceca095$export$6fa04827ac68a4fb = "#006644";
var $0320890a3ceca095$export$226de0355ed012f8 = "#DEEBFF";
var $0320890a3ceca095$export$8c13c2ee36917869 = "#B3D4FF";
var $0320890a3ceca095$export$ecfc1dff386a3e7a = "#4C9AFF";
var $0320890a3ceca095$export$215b7063051591f1 = "#2684FF";
var $0320890a3ceca095$export$e62e8919cca44969 = "#0065FF";
var $0320890a3ceca095$export$b3de0ae08da2ce64 = "#0052CC";
var $0320890a3ceca095$export$a6ee3d71bc067634 = "#0747A6";
var $0320890a3ceca095$export$67f15409e87642a1 = "#669DF1";
var $0320890a3ceca095$export$f0539dbc42dbb067 = "#8FB8F6";
var $0320890a3ceca095$export$363e4475840015bb = "#EAE6FF";
var $0320890a3ceca095$export$4b0a4417ed59760f = "#C0B6F2";
var $0320890a3ceca095$export$6011520a64d9a187 = "#998DD9";
var $0320890a3ceca095$export$a7175d4e9206bc80 = "#8777D9";
var $0320890a3ceca095$export$b48405b95304b5a1 = "#6554C0";
var $0320890a3ceca095$export$c71e4279dd54a18d = "#5243AA";
var $0320890a3ceca095$export$147899de772240ec = "#403294";
var $0320890a3ceca095$export$2cf711fe14c66f06 = "#E6FCFF";
var $0320890a3ceca095$export$7a8f4d33f6f9772c = "#B3F5FF";
var $0320890a3ceca095$export$776c9c497ef08533 = "#79E2F2";
var $0320890a3ceca095$export$69cb3ca10c1e330e = "#00C7E6";
var $0320890a3ceca095$export$9dc1ef0f3f48059b = "#00B8D9";
var $0320890a3ceca095$export$7c835c78b6fcdef8 = "#00A3BF";
var $0320890a3ceca095$export$6036577f95c3877e = "#008DA6";
var $0320890a3ceca095$export$29a4f05edc054374 = "#FFFFFF";
var $0320890a3ceca095$export$e655ef011c4aa1a2 = "#FAFBFC";
var $0320890a3ceca095$export$9fdfb749e33cdf97 = "#F4F5F7";
var $0320890a3ceca095$export$3e51e8f1440314ba = "#EBECF0";
var $0320890a3ceca095$export$1ce2d1575d444ceb = "#DFE1E6";
var $0320890a3ceca095$export$8754fc7e6d8b3000 = "#C1C7D0";
var $0320890a3ceca095$export$c2e91cbeada39b8b = "#B3BAC5";
var $0320890a3ceca095$export$5f71e19f3a7ad9de = "#A5ADBA";
var $0320890a3ceca095$export$eaa8c8a70ac22806 = "#97A0AF";
var $0320890a3ceca095$export$7c87d337fb91a97d = "#8993A4";
var $0320890a3ceca095$export$d6447c357493214f = "#7A869A";
var $0320890a3ceca095$export$f563ee71e9ee74cd = "#6B778C";
var $0320890a3ceca095$export$e2ef2124cf4024b1 = "#5E6C84";
var $0320890a3ceca095$export$eece5f492e429f08 = "#505F79";
var $0320890a3ceca095$export$c39c0fe0f26207ae = "#42526E";
var $0320890a3ceca095$export$7090862dc3038a9f = "#344563";
var $0320890a3ceca095$export$ad0bacf983b7ddaa = "#253858";
var $0320890a3ceca095$export$7d61b15e0da132af = "#172B4D";
var $0320890a3ceca095$export$fbda843f0a27fe96 = "#091E42";
var $0320890a3ceca095$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $0320890a3ceca095$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $0320890a3ceca095$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $0320890a3ceca095$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $0320890a3ceca095$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $0320890a3ceca095$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $0320890a3ceca095$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $0320890a3ceca095$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $0320890a3ceca095$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $0320890a3ceca095$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $0320890a3ceca095$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $0320890a3ceca095$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $0320890a3ceca095$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $0320890a3ceca095$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $0320890a3ceca095$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $0320890a3ceca095$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $0320890a3ceca095$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $0320890a3ceca095$export$2f6319cf7d736c2a = "#E6EDFA";
var $0320890a3ceca095$export$95126bc8884d6634 = "#DCE5F5";
var $0320890a3ceca095$export$8338d8c35d44ff1 = "#CED9EB";
var $0320890a3ceca095$export$5368d76ae4fbbda7 = "#B8C7E0";
var $0320890a3ceca095$export$9f0a771d16ec8d36 = "#ABBBD6";
var $0320890a3ceca095$export$abcf8c38338b4aa5 = "#9FB0CC";
var $0320890a3ceca095$export$97e81faa16a182c7 = "#8C9CB8";
var $0320890a3ceca095$export$bfe21c59123ecf33 = "#7988A3";
var $0320890a3ceca095$export$ee82aa2ea6a1558 = "#67758F";
var $0320890a3ceca095$export$682927c6ed76be02 = "#56637A";
var $0320890a3ceca095$export$91fd9994c5be9757 = "#455166";
var $0320890a3ceca095$export$d281fbfe3cff2df6 = "#3B475C";
var $0320890a3ceca095$export$3902c91d8b98a753 = "#313D52";
var $0320890a3ceca095$export$8e8133c1ba5845b5 = "#283447";
var $0320890a3ceca095$export$33ff357f6620b39 = "#202B3D";
var $0320890a3ceca095$export$633847cf062b69e0 = "#1B2638";
var $0320890a3ceca095$export$9776a6e503bdbf76 = "#121A29";
var $0320890a3ceca095$export$6c813d5160dff5db = "#0E1624";
var $0320890a3ceca095$export$3d4f271a500072a = "#0D1424";
var $0320890a3ceca095$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $0320890a3ceca095$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $0320890a3ceca095$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $0320890a3ceca095$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $0320890a3ceca095$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $0320890a3ceca095$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $0320890a3ceca095$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $0320890a3ceca095$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $0320890a3ceca095$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $0320890a3ceca095$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $0320890a3ceca095$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $0320890a3ceca095$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $0320890a3ceca095$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $0320890a3ceca095$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $0320890a3ceca095$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $0320890a3ceca095$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $0320890a3ceca095$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $0320890a3ceca095$export$d2adc5dedf09fced = "#292A2E";
var $0320890a3ceca095$export$f51762073d2bb381 = "#94C748";
var $0320890a3ceca095$export$95e26d54def96891 = "#B3DF72";

});




//# sourceMappingURL=VerifyEmailSentPage.f26d572c.js.map
